import React, { useEffect, useState } from 'react';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import { Container, Row, Col, Table, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as Picklist from '../../Picklist';
import * as Common from "../../Common";
import AsyncSelect from 'react-select/async';
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import $ from "jquery";
import { faEye, faCopy } from '@fortawesome/free-regular-svg-icons';
import FaView from '../../FaView';
import Tran_data_unlock_request from '../../Tran_data_unlock_request';
import CancelDialog from '../../CancelDialog';


function Tran_cross_knockoff() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');

    const [userRight, setUserRight] = useState([]);
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [hdrLocation, setHdrLocation] = useState(null);
    const [radioType, setRadioType] = useState("N");
    const [scrMode, setScrMode] = useState("");
    const [nDate, setNDate] = useState(new Date())
    const [hdrLocationName, setHdrLocationName] = useState("");
    const [hdrSrno, setHdrSrno] = useState(0);
    const [hdrDate, setHdrDate] = useState("");
    const [nAmount, setNAmount] = useState("");

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    const [flag, setFlag] = useState("D");
    const [ledgerValue, setLedgerValue] = useState(null);
    const [grpCode, setGrpCode] = useState("");
    const [accCode, setAccCode] = useState("");
    const [isKnockOff, setIsKnockOff] = useState("0");

    const [knockoffValue, setKnockoffValue] = useState(null);
    const [nLocation, setNLocation] = useState(null);
    const [nLocatinCode, setNLocatinCode] = useState("");
    const [nLocationName, setNLocationName] = useState("");

    const [crAccCode, setCrAccCode] = useState("");
    const [crGrpCode, setCrGrpCode] = useState("");
    const [crFlag, setCrFlag] = useState("C");
    const [crKnockoffValue, setCrKnockoffValue] = useState(null);
    const [crLedgerValue, setCrLedgerValue] = useState(null);

    const [crIsKnockOff, setCrIsKnockOff] = useState("0");

    const [crLocation, setCrLocation] = useState(null);
    const [crLocationCode, setCrLocationCode] = useState("");
    const [hdrData, setHdrData] = useState([]);
    const [prevAmount, setPrevAmount] = useState("0");

    const [billNum1, setBillNum1] = useState("");
    const [billNum2, setBillNum2] = useState("");

    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);

    const [srnoFrom, setSrnoFrom] = useState("");
    const [srnoTo, setSrnoTo] = useState("");
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());

    const [narration, setNarration] = useState("");
    const [randomNum, setRandomNum] = useState("");

    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");
    const [unlockRequestType, setUnlockRequestType] = useState("");

    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });

    const [hdrDateYmd, setHdrDateYmd] = useState("");
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");

    useEffect(() => {
        Common.getActiveBranch().then(response => {
            response != null && handleLocationChange(response);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_CROSS_KNOCKOFF'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/');
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserCancelBillRight(resp);
            }
        });
    }, []);


    const handleLocationChange = (value) => {
        setHdrLocation(value);
        setNLocation(value);
        var v = value.id.split("^");
        setNLocatinCode(v[1]);
        setNLocationName(v[2]);
        setHdrLocationName(v[2]);
        setHdrData([]);
        sessionStorage.activeBranch = v[1];
        setIsBranchDisableForAddNew(v[9]);

    }

    const addNewForm = () => {
        var d = Common.dateYMD(nDate);
        var today = Common.dateYMD(new Date());
        if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        }
        else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        }
        else {
            if (d == today) {
                addNewFormResetFields();
            } else {
                const obj = {
                    billdate: d,
                    location: nLocatinCode,
                    type: 'CRKNF'
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (resp.msg === "1") {
                        addNewFormResetFields();
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = () => {
        setScrMode("A");
        setHdrSrno("0");
        setHdrDate(Common.dateDMY(nDate));
        setFlag("C");
        setCrFlag("D");
        setLedgerValue(null);
        setCrLedgerValue(null);
        setKnockoffValue(null);
        setCrKnockoffValue(null);
        setCrLocation(null);
        setNAmount("");
        setNarration("");
        setRandomNum(Common.getRandomString(15));
        setHdrDateYmd("");
    }

    const listCrossFa = () => {
        var msg = [];
        var i = 0;
        var d = Common.dateYMD(srnoFrom);
        if (radioType === "S" && (srnoFrom.trim() == "" || srnoTo.trim() === "")) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (srnoFrom === "" ? "From Srno" : "");
            msg[i++] = (srnoTo === "" ? "To Srno" : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else if (radioType === "D" && (fromDate === null || toDate === null)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (fromDate === null ? "From Date" : "");
            msg[i++] = (toDate === null ? "To Date" : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else {
            $(".loader").show();
            const obj = {
                type: "CRKNF",
                srnoFrom: srnoFrom,
                srnoTo: srnoTo,
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                radioType: radioType,
                location: nLocatinCode
            }
            Common.callApi(Common.apiCrossKnockoff, [sid, "listdata", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setHdrData(resp.data);
            });
        }
    }

    const btnEditRequest = () => {
        setScrMode("E");
    }

    const fillViewForm = (item) => {
        $(".loader").show();
        setHdrSrno(item.thrk_srno);
        setScrMode("Q");
        const obj = {
            srno: item.thrk_srno,
            type: item.thrk_type,
            loc1: item.thrk_loc_1,
            flag1: item.thrk_flag_1,
            grpcode1: item.thrk_group_1,
            acccode1: item.thrk_account_1,
            loc2: item.thrk_loc_2,
            flag2: item.thrk_flag_2,
            grpcode2: item.thrk_group_2,
            acccode2: item.thrk_account_2,
            date: item.thrk_date,
        }
        Common.callApi(Common.apiCrossKnockoff, [sid, 'viewdata', JSON.stringify(obj)], result => {
            $(".loader").hide();
            let res = JSON.parse(result);
            let resp = res.data[0];
            handleLocationChange({ id: resp.e1id, label: resp.e1label });
            handleCrLocationChange({ id: resp.e2id, label: resp.e2label });
            setFlag(resp.thrk_flag_1);
            setCrFlag(resp.thrk_flag_2);
            setLedgerValue({ id: resp.a1id, label: resp.a1label });
            setCrLedgerValue({ id: resp.a2id, label: resp.a2label });
            setGrpCode(resp.grpcode1);
            setAccCode(resp.acctcode1);
            setCrGrpCode(resp.grpcode2);
            setCrAccCode(resp.acctcode2);
            setNAmount(resp.thrk_amount);
            setPrevAmount(resp.thrk_amount);
            setHdrDate(resp.thrk_date);
            setHdrDateYmd(resp.thrk_date_ymd);
            if (res.knockoff_1 != "") {
                setKnockoffValue(res.knockoff_1);
                let a = res.knockoff_1.id.split("^");
                setBillNum1(a[2] + " " + a[3]);
            } else {
                setBillNum1("");
                setKnockoffValue(null);
            }
            if (res.knockoff_2 != "") {
                setCrKnockoffValue(res.knockoff_2);
                let a = res.knockoff_2.id.split("^");
                setBillNum2(a[2] + " " + a[3]);
            }
            else {
                setCrKnockoffValue(null);
                setBillNum2("");
            }
            setNarration(resp.thrk_narration);
            setRandomNum(resp.random_rum);
        });
    }

    const saveData = () => {
        let msg = [];
        let i = 0;
        if (ledgerValue == null || knockoffValue === null ||
            crLocation === null || crLedgerValue === null ||
            crKnockoffValue === null || nAmount.trim() == "" ||
            nAmount == "0" || narration.trim() === "") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ledgerValue === null ? "Ledger" : "");
            msg[i++] = (knockoffValue === null ? "Select Knock Off" : "");
            msg[i++] = (crLocation === null ? "Cross location" : "");
            msg[i++] = (crLedgerValue === null ? "Cross Ledger" : "");
            msg[i++] = (crKnockoffValue === null ? "Cross Knock Off" : "");
            msg[i++] = ((nAmount == "" || nAmount == "0") ? "Amount" : "");
            msg[i++] = (narration.trim() === "" ? "Narration" : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else {
            $(".loader").show();
            const obj = {
                srno: hdrSrno,
                type: 'CRKNF',
                flag: flag,
                nLocatinCode: nLocatinCode,
                ledgerValue: ledgerValue,
                knockoffValue: knockoffValue,
                crFlag: crFlag,
                crLocationCode: crLocationCode,
                crLedgerValue: crLedgerValue,
                crKnockoffValue: crKnockoffValue,
                grpCode: grpCode,
                accCode: accCode,
                crGrpCode: crGrpCode,
                crAccCode: crAccCode,
                hdrDate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(nDate),
                amount: nAmount,
                prevAmount: prevAmount,
                srnoFrom: srnoFrom,
                srnoTo: srnoTo,
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                radioType: radioType,
                location: nLocatinCode,
                narration: narration
            }
            Common.callApi(Common.apiCrossKnockoff, [sid, "savedata", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.msg == "1") {
                    setScrMode("");
                    setHdrData(resp.data);
                } else {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
            });
        }
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    const handleFlagChange = (v) => {
        setFlag(v);
        setKnockoffValue(null);
    }

    const handleLedgerValue = (value) => {
        setLedgerValue(value);
        const account = value.id.split('^');
        setGrpCode(account[1]);
        setAccCode(account[2]);
        setKnockoffValue(null);
        const obj = {
            groupCode: account[1],
            flag: flag == "C" ? "D" : "C"
        }
        Common.callApi(Common.apiCrossKnockoff, [sid, "checkknockoff", JSON.stringify(obj)], result => {
            const res = JSON.parse(result);
            setIsKnockOff(res.isknockoff);
        });
    }

    const handleKnockoffValue = (value) => {
        setKnockoffValue(value);
        const knockoff = value.id.split('^');
        setNAmount(knockoff[8]);
        // setKnockoffSrno(knockoff[3]);
        // setKnockoffType(knockoff[2]);
        // // setKnockoffAmt(knockoff[6]);
        // setKnockoffLineNo(knockoff[4]);
        // // setKnockoffPending(knockoff[8]);
        // setKnockoffFlag(knockoff[9]);
        // setKnockoffLedger(knockoff[10]);
    }

    const handleNewLocationChange = (value) => {
        setNLocation(value);
    }

    const handleCrLocationChange = (value) => {
        setCrLocation(value);
        setCrLocationCode(value.id.split("^")[1]);
        setCrKnockoffValue(null);
    }

    const handleCrFlagChange = (v) => {
        setCrFlag(v);
        setCrKnockoffValue(null);
    }

    const handleCrLedgerValue = (value) => {
        setCrLedgerValue(value);
        const account = value.id.split('^');
        setCrGrpCode(account[1]);
        setCrAccCode(account[2]);
        setCrKnockoffValue(null);
        const obj = {
            groupCode: account[1],
            flag: crFlag == "C" ? "D" : "C"
        }
        Common.callApi(Common.apiCrossKnockoff, [sid, "checkknockoff", JSON.stringify(obj)], result => {
            const res = JSON.parse(result);
            setCrIsKnockOff(res.isknockoff);
        });
    }

    const handleCrKnockoffValue = (value) => {
        setCrKnockoffValue(value);
        const knockoff = value.id.split('^');
        // setCrKnockoffSrno(knockoff[3]);
        // setCrKnockoffType(knockoff[2]);
        // // setKnockoffAmt(knockoff[6]);
        // setCrKnockoffLineNo(knockoff[4]);
        // // setKnockoffPending(knockoff[8]);
        // setCrKnockoffFlag(knockoff[9]);
        // setCrKnockoffLedger(knockoff[10]);
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: nLocatinCode, trannumber: hdrSrno, type: 'CRKNF' });
    }

    const handleCancelBill = () => {
        const currDate = new Date();
        const newDate = hdrDate.split('/');
        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0];
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        // console.log(differenceInDays);
        const obj = {
            srno: hdrSrno,
            type: 'CRKNF',
            pageright: 'TRAN_BOOK_ENTRY',
            location: nLocatinCode
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'CRKNF', trannumber: hdrSrno, location: nLocatinCode, tranDate: Common.dateYMD(currDate) });
            }
        })


    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'CRKNF',
            location1: nLocatinCode,
            location2: crLocationCode,
            srno: hdrSrno,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }

    function copyNarrationValue(val) {
        const narration = val?.label?.split(' ')[7]?.split(':')[1]?.split("^")?.join(' ');
        navigator.clipboard.writeText(narration || '');
    }


    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col><h2>Cross KnockOff</h2></Col>
                    <hr />
                </Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "20px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" selected />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={hdrLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={(value) => handleLocationChange(value)}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === "N" ?
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={nDate}
                                                    onChange={(date) => setNDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        : radioType === "S" ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={10} value={srnoFrom} onChange={e => Common.validateNumValue(e.target.value, setSrnoFrom)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={10} value={srnoTo} onChange={e => Common.validateNumValue(e.target.value, setSrnoTo)} />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={fromDate}
                                                            onChange={(date) => setFromDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={toDate}
                                                            onChange={(date) => setToDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" && (radioType !== "N" && radioType !== "R") ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={listCrossFa}>List</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        userRight.add === "1" && radioType === "N" ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={addNewForm}>Add New</Button> : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Table responsive striped bordered>
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Srno</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>Loc 1</th>
                                            <th>Loc 2</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            hdrData.map(item => (
                                                <tr key={item.thrk_srno}>
                                                    <td>
                                                        <span className='handCursor colorThemeBlue' onClick={() => fillViewForm(item)}>
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    </td>
                                                    <td>{item.thrk_srno}</td>
                                                    <td>{item.thrk_date}</td>
                                                    <td>{item.thrk_amount}</td>
                                                    <td>{item.thrk_loc_1} {item.thrk_loc_1_name}</td>
                                                    <td>{item.thrk_loc_2} {item.thrk_loc_2_name}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>&nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.query === "1" && scrMode === "Q") ?
                                            <>
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>
                                            </>
                                            : null
                                    }
                                    {
                                        (scrMode === "Q" && userCancelBillRight.query === "1") &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Location : <b>{hdrLocationName} </b></span>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Date : <b>{hdrDate}</b></span>
                                </Col>
                                <Col className='col-md-3 col-6' style={{ textAlign: "right" }}>
                                    <Form.Group>
                                        <Form.Control
                                            value={nAmount}
                                            maxLength={Common.maximumLength}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setNAmount)}
                                            placeholder="Amount"
                                            disabled={scrMode === "Q"}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            {/* -------------------- Allowed Location ------------------- */}
                            {
                                scrMode === "Q" &&
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>KnockedOff Bill : <b>{billNum1}</b></Form.Label>
                                    </Col>
                                </Row>
                            }
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={nLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={(value) => handleNewLocationChange(value)}
                                            isDisabled
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Cr/Dr<span className="text-danger">*</span></Form.Label>
                                        <Form.Select disabled={scrMode === "Q"} value={flag} onChange={(e) => handleFlagChange(e.target.value)} required>
                                            <option value="C">Credit</option>
                                            <option value="D">Debit</option>
                                        </Form.Select>
                                    </Form.Group>

                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Account<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={ledgerValue}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, nLocatinCode)} // location = 1 , 2
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLedgerValue}
                                            isDisabled={scrMode === "Q"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </Row>
                            {
                                scrMode !== "Q" &&
                                <>
                                    <Row>
                                        <Col className='col-12'>
                                            <Form.Group>
                                                <Form.Label>Knockoff<span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={knockoffValue}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchKnockoffPicklist(search, nLocatinCode, `${flag}^${grpCode}^${accCode}^${Common.dateYMD(nDate)}^${randomNum}`)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleKnockoffValue}
                                                    formatOptionLabel={Picklist.knockOffFormatOptionLabel}
                                                    components={{ Menu: Picklist.knockkOffMenu }}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            Narration : {knockoffValue?.label?.split(' ')[7]?.split(':')[1]?.split("^")?.join(' ')}
                                            <span className='colorThemeBlue' onClick={() => copyNarrationValue(knockoffValue)}>
                                                <FontAwesomeIcon icon={faCopy} />
                                            </span>
                                        </Col>

                                    </Row>
                                </>
                            }
                            <hr />
                            {/* -------------------- Cross Location ------------------- */}
                            {
                                scrMode === "Q" &&
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Knocked Off Bill  : <b>{billNum2}</b></Form.Label>
                                    </Col>
                                </Row>
                            }
                            <Row>

                            </Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={crLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={(value) => handleCrLocationChange(value)}
                                            isDisabled={branchDisable === "true" || scrMode === "Q"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Cr/Dr<span className="text-danger">*</span></Form.Label>
                                        <Form.Select disabled={scrMode === "Q"} value={crFlag} onChange={(e) => handleCrFlagChange(e.target.value)} required>
                                            <option value="C">Credit</option>
                                            <option value="D">Debit</option>
                                        </Form.Select>
                                    </Form.Group>

                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Account<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={crLedgerValue}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, crLocationCode)} // location = 1 , 2
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleCrLedgerValue}
                                            isDisabled={scrMode === "Q"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </Row>
                            {
                                scrMode !== "Q" &&
                                <>
                                    <Row>
                                        <Col className='col-12'>
                                            <Form.Group>
                                                <Form.Label>Knockoff<span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={crKnockoffValue}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchKnockoffPicklist(search, crLocationCode, `${crFlag}^${crGrpCode}^${crAccCode}^${Common.dateYMD(nDate)}^${randomNum}`)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleCrKnockoffValue}
                                                    formatOptionLabel={Picklist.knockOffFormatOptionLabel}
                                                    components={{ Menu: Picklist.knockkOffMenu }}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            Narration : {crKnockoffValue?.label?.split(' ')[7]?.split(':')[1]?.split("^")?.join(' ')}
                                            <span className='colorThemeBlue' onClick={() => copyNarrationValue(crKnockoffValue)}>
                                                <FontAwesomeIcon icon={faCopy} />
                                            </span>
                                        </Col>
                                    </Row>
                                </>
                            }
                            <Row>
                                <Col className='col-md-8 col-12'>
                                    <Form.Group>
                                        <Form.Label>Narration<span className='text-danger'>*</span></Form.Label>
                                        <Form.Control disabled={scrMode === "Q"} as="textarea" rows={2}
                                            maxLength={500} value={narration}
                                            // style={{ height: '100px' }}
                                            onChange={e => setNarration(e.target.value)} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>&nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.query === "1" && scrMode === "Q") ?
                                            <>
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                            </>
                                            : null
                                    }
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row><Col>&nbsp;</Col></Row>
                        </>
                }
            </Container >
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                {msgTextYNBillDelete}
            </CancelDialog>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
        </>
    )
}

export default Tran_cross_knockoff
